import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type PaymentDetailsPopupComponent = EntryPointComponent<
	Record<string, never>,
	Record<string, never>,
	{
		onClose: (extraInformation?: unknown) => void;
	},
	Record<string, never>
>;

export const entryPoint: EntryPoint<PaymentDetailsPopupComponent, {}> = createEntryPoint({
	root: JSResourceForInteraction<PaymentDetailsPopupComponent>(
		/* webpackChunkName: "@atlaskit-internal_edition-awareness-payment-details-popup" */ './payment-details-popup',
		{
			moduleId: 'edition-awareness-payment-details-popup',
		},
	),
	getPreloadProps: () => ({
		entryPoints: {},
		extraProps: {},
		queries: {},
	}),
});
